import axios from "axios";
import { openUpgrade } from "@/lib/plans";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Plan-gated endpoints answer 402; surface a global upgrade prompt.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const d = err?.response?.data?.detail;
    if (err?.response?.status === 402 && d?.code && !err.config?.silentUpgrade) openUpgrade(d);
    return Promise.reject(err);
  }
);

// Re-export shared constants for backward compatibility
export { LEAGUES, EMOTION_TAGS, AI_MODES, CONTENT_STYLES, LANGUAGES, ONBOARDING_LEAGUES } from "@/lib/constants";
